export const mockProjects = [
  {
    id: 'p1',
    name: 'Cyberpunk Visor V2',
    status: 'building',
    progress: 65,
    dueDate: '2023-11-15',
    category: 'Prop Making',
    budget: 150,
    spent: 85,
    tags: ['3D Print', 'LEDs', 'Painting'],
  },
  {
    id: 'p2',
    name: 'Walnut Standing Desk',
    status: 'design',
    progress: 15,
    dueDate: '2023-12-01',
    category: 'Woodworking',
    budget: 800,
    spent: 450,
    tags: ['Lumber', 'Epoxy', 'Hardware'],
  },
  {
    id: 'p3',
    name: 'Neon Sign "Create"',
    status: 'finishing',
    progress: 90,
    dueDate: '2023-10-30',
    category: 'Electronics',
    budget: 60,
    spent: 55,
    tags: ['LED Strip', 'Acrylic', 'Soldering'],
  }
];

export const mockInventory = [
  { id: 'i1', name: 'PLA Filament (Black)', qty: 2.5, unit: 'kg', costPerUnit: 22, status: 'good', bin: 'A-12' },
  { id: 'i2', name: 'High-Density EVA Foam', qty: 4, unit: 'sheets', costPerUnit: 15, status: 'low', bin: 'B-04' },
  { id: 'i3', name: 'Addressable LED Strip 5m', qty: 3, unit: 'rolls', costPerUnit: 25, status: 'good', bin: 'E-01' },
  { id: 'i4', name: 'Walnut Slab (Live Edge)', qty: 1, unit: 'pcs', costPerUnit: 350, status: 'good', bin: 'W-01' },
  { id: 'i5', name: 'Epoxy Resin (Clear)', qty: 0.5, unit: 'gal', costPerUnit: 80, status: 'critical', bin: 'C-08' },
  { id: 'i6', name: 'Acrylic Paint Set', qty: 1, unit: 'set', costPerUnit: 45, status: 'good', bin: 'P-02' },
];

export const mockTasks = [
  { id: 't1', projectId: 'p1', task: 'Sand and prime helmet base', done: true },
  { id: 't2', projectId: 'p1', task: 'Wire LED matrix', done: false },
  { id: 't3', projectId: 'p2', task: 'Mill walnut boards', done: true },
  { id: 't4', projectId: 'p2', task: 'Glue up table top', done: false },
];